module.exports = __webpack_public_path__ + "img/527dd28.jpg";